export default __webpack_public_path__ + "static/media/BusinessHero.e132ba7f.png";